import { Reducer } from 'redux';
import { AgrupamentosState, AgrupamentosTypes } from './types';

const INITIAL_STATE: AgrupamentosState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<AgrupamentosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AgrupamentosTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AgrupamentosTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case AgrupamentosTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
